import type { ReactNode } from "react";
import Navbar from "./_components/navbar";

type Props = {
  children: ReactNode;
};

export default function WebLayout({ children }: Props) {
  return (
    <>
      <Navbar />
      {children}
    </>
  );
}
